export const ver_pre = /* glsl */ `
varying highp vec2 vUv;
varying vec3 vWorldPosition;
varying vec3 vViewDirection;
`

export const ver = /* glsl */ `
#include <begin_vertex>

vec4 worldPosition1 = modelMatrix * vec4(position, 1.0);
vWorldPosition = worldPosition1.xyz;
    // 计算视线方向（从顶点指向相机）
vViewDirection = normalize(cameraPosition - worldPosition1.xyz);
`

export const frag_pre = /* glsl */ `
varying highp vec2 vUv;
varying vec3 vWorldPosition;
uniform float progress;
uniform float objSize;
uniform bool isFadeIn;
uniform vec3 center;
`

export const frag = /* glsl */ `
#include <map_fragment>
vec3 myWorldPosition = vWorldPosition / objSize;

if (progress == 0.0) {
    diffuseColor.w = 0.0;
} else if (progress == 1.0) {
   
} else{
if (isFadeIn) {
    float circle1 = step(distance(center / objSize, myWorldPosition), progress - 0.002);
    float circle2 = step(distance(center / objSize, myWorldPosition), progress);

    diffuseColor.xyz += vec3(circle2 - circle1) * 3.;
    diffuseColor.w *= circle2;
} else {
    float circle = step(distance(center / objSize, myWorldPosition), progress);
    diffuseColor.w *= step(circle, 0.);
}
}

`

const RealFadeObjS = { ver_pre, ver, frag_pre, frag }

export default RealFadeObjS